/**
 * Akten-Link helpers — single source of truth for how we address an Akte in URLs.
 *
 * The `akten` table carries two near-identical columns: `akten_nummer` (NOT NULL,
 * authoritative) and `akten_nr` (nullable historical copy). Any code that picks
 * one of them blindly risks producing broken URLs when a row has only one column
 * populated. Always prefer `akten_nummer` and fall back to `akten_nr`.
 */

export interface AkteLinkFields {
  akten_nummer?: string | null;
  akten_nr?: string | null;
}

/**
 * Pick the best identifier to use in URLs. `akten_nummer` is authoritative;
 * `akten_nr` is a fallback for legacy rows.
 */
export function aktenIdentifier(row: AkteLinkFields): string | null {
  const ident = row.akten_nummer ?? row.akten_nr ?? null;
  if (!ident) return null;
  const trimmed = ident.trim();
  return trimmed || null;
}

/** Build the `/akten/:betrieb/:aktenNr/:section` URL for an Akte. */
export function buildAkteHref(
  businessUnit: string,
  identifier: string,
  section: string = 'uebersicht',
): string {
  return `/akten/${businessUnit}/${identifier}/${section}`;
}
